export function isAuth(): boolean | null {
    const tok = localStorage.getItem("__timed_user_token__");
    if(tok){
        return true;
    }
    return false;
}